// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1MH-A","left":"InfoRow_left__mg2mO"};